import { useEffect, useState } from 'react'
import { usePrepListSettings } from "./hooks/usePrepListSettings"
import 'jsoneditor-react/es/editor.min.css';
import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/monokai';
import Stack from 'rsuite/Stack'
import Button from 'rsuite/Button'
import Message from 'rsuite/Message'
// @ts-ignore
import { JsonEditor } from 'jsoneditor-react';
import Loader from 'rsuite/Loader'
import './PrepListSettings.css'
import { useUpdatePrepListSettings } from './hooks/useUpdatePrepListSettings';
import { useToaster } from 'rsuite/esm/toaster'

const PrepListSettings = () => {
  const [json, setJson] = useState<any>();
  const { data } = usePrepListSettings();
  const { mutate: updatePrepList, isLoading: savingInProgress } = useUpdatePrepListSettings();
  const toaster = useToaster();

  useEffect(() => {
    if (!data) {
      return;
    }

    setJson(data)
  }, [data])

  const handleEditorChange = (value: any) => {
    setJson(value || {})
  }

  const handleSave = () => {
    updatePrepList(json, {
      onSuccess: () => {
        const message = "Prep list saved successfully";
        toaster.push(
          <Message showIcon type='success' closable>
            {message}
          </Message>,
          { placement: 'topEnd', duration: 3000 }
        )
      },
      onError: () => {
        const message = "Error while saving prep list. Please try again.";
        toaster.push(
          <Message showIcon type='error' closable>
            {message}
          </Message>,
          { placement: 'topEnd', duration: 3000 }
        )
      }
    })
  }

  return (
    <div>
      {json
        ? <JsonEditor
          value={json}
          onChange={handleEditorChange}
          mode='code'
          ace={ace}
          theme="ace/theme/monokai"
          allowedModes={['code', 'tree']}
        />
        : <Loader center />
      }
      <Stack style={{marginTop: '8px', marginBottom: '8px'}} direction='row-reverse'>
        <Button onClick={handleSave} appearance='primary'>
          {savingInProgress && <Loader style={{marginRight: '8px'}} />}
          Save
        </Button>
      </Stack>
    </div>

  )
}

export default PrepListSettings